import React from 'react'

export default function About() {
    return (
        <div>
            <p>
                This appication is used to convert <b>uppercase</b> and <b>lowercase</b> of any text or sentence.
                Simply write or <b>copy</b> and <b>paste</b> the text into the text area below and click the required button.
                You can also copy your sentence by clicking on the <mark>Copy Text</mark> button and clear your sentence by
                clicking on the <mark>Clear Text</mark> button. Appication count number of <b>characters</b> and number of
                <b> words</b> in your sentence. It suggest the minimum required time to read your sentence.
            </p>

        </div>
    )
}
